import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import List from './modules/List';
import { useActivityLogContext } from './ActivitiyLogContext';

function AccountActivityLog() {

  const {
    loading,
  } = useActivityLogContext();

  return (
    <>
      {(!loading) && (
        <div data-component="AccountActivityLog">
          <div className="sui-box-content">
            <Typography variant="h2" weight="display">RECENT ACTIVITY</Typography>
            <List />
          </div>
        </div>
      )}
    </>
  );
}

AccountActivityLog.propTypes = {};

AccountActivityLog.displayName = 'AccountActivityLog';

AccountActivityLog.dataModel = {};

export { AccountActivityLog };
